<template>
  <DataTable :download-url="downloadUrl" permissions="Feedback and Complaint,Feedback and Complaints" :key="rows.length"
    :perpage.sync="query.per_page" :currentPage.sync="query.page" :search.sync="query.search"
    :total.sync="query.last_page" :rows.sync="rows" :table-fields="FEEDBACK_COMPLAINT_TABLE_FIELD" :downloadable="true"
    @apply-filter="setFilterValue" @reset-filter="setFilterValue('reset')">
    <template #filter>
      <div class="row">
        <div class="col-xl-6 col-sm-6">
          <FieldSelect name="Month" :options="options.months" v-model="filter.filter_month" />
        </div>
        <div class="col-xl-6 col-sm-6">
          <FieldTextInput name="Grade" v-model="filter.filter_grade" />
        </div>
        <div class="col-xl-6 col-sm-6">
          <FieldAsyncSelect name="Status" v-model="filter.filter_status" :options-handlers="getStatus"
            :searchable="false" />
        </div>
        <div class="col-xl-6 col-sm-6">
          <FieldTextInput name="Application" v-model="filter.filter_application" />
        </div>
        <div class="col-xl-6 col-sm-6">
          <FieldTextInput name="Issue" v-model="filter.filter_issue" />
        </div>
        <div class="col-xl-6 col-sm-6">
          <FieldSelect name="Years" :options="options.years" v-model="filter.filter_year" />
        </div>
      </div>
    </template>

    <template #cell(customer)="{ customer }">
      <span>{{ customer?.name }}</span>
    </template>
    <template #cell(status)="{ status }">
      <div class="status"
        :style="`background-color: ${statusBackground(status, 'status')}1a;color: ${statusBackground(status, 'status')};text-transform: Capitalize;`">
        {{ status?.label }}
      </div>
    </template>
    <template #cell(detail_status)="{ detail_status }">
      <div class="status" :style="`background-color: ${statusBackground(detail_status, 'detail_status')}1a;
             color: ${statusBackground(detail_status, 'detail_status')};
             text-transform: capitalize;`">
        <template v-if="detail_status?.label?.includes(' - ')">
          {{ detail_status.label.split(' - ')[0] }} -<br />
          {{ detail_status.label.split(' - ')[1] }}
        </template>
        <template v-else>
          {{ detail_status?.label }}
        </template>
      </div>
    </template>
    <template #cell(assigned_to)="{ assigned_to }">
      <div class="d-flex flex-row gap-2">
        <div v-for="employee in assigned_to" :key="employee.id" class="status w-fit"
          :style="`background-color: #0000001a;color: #000000;text-transform: Capitalize;`">
          {{ employee?.assignee?.code ?? employee?.assignee?.name }}
        </div>
      </div>
    </template>
    <template #table-action(edit)>
      <span></span>
    </template>
  </DataTable>
</template>

<script>
import axios from '@/axios';
import DataTable from "@/components/DataTable.vue";
import { FEEDBACK_COMPLAINT_TABLE_FIELD } from "@/constants/table-field.js";
import { showErrorMessage, truncate } from '@/utils';
import { getOptions } from '@/utils/fetch.js'
import { API_ENDPOINT } from '@/constants/api-endpoint.js'

import FieldSelect from '@/components/field/Select.vue';
import FieldAsyncSelect from '@/components/field/AsyncSelect.vue';
import FieldTextInput from '@/components/field/TextInput.vue';
import { DETAIL_STATUS, getStatusColor, STATUS } from '@/constants/feedback-n-complaint';
import { getMonthList, getYearList } from '@/constants/options';

export default {
  components: { DataTable, FieldSelect, FieldTextInput, FieldAsyncSelect },
  data() {
    return {
      query: {
        per_page: this.$route?.query?.per_page || 10,
        page: this.$route?.query?.page || 1,
        search: this.$route?.query?.search || '',

        filter_month: this.$route?.query?.filter_month || '',
        filter_year: this.$route?.query?.filter_year || '',
        filter_grade: this.$route?.query?.filter_grade || '',
        filter_status: this.$route?.query?.filter_status || '',
        filter_issue: this.$route?.query?.filter_issue || '',
        filter_application: this.$route?.query?.filter_application || '',

        // hook
        last_page: 0,
      },

      filter: {
        filter_month: this.$route?.query?.filter_month || '',
        filter_year: this.$route?.query?.filter_year || '',
        filter_grade: this.$route?.query?.filter_grade || '',
        filter_status: this.$route?.query?.filter_status || '',
        filter_issue: this.$route?.query?.filter_issue || '',
        filter_application: this.$route?.query?.filter_application || '',
      },

      rows: [],
      // constants
      getStatusColor,
      FEEDBACK_COMPLAINT_TABLE_FIELD,
      DETAIL_STATUS,
      STATUS,
      truncate
    }
  },
  methods: {
    async get() {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        const res = await axios.get(`/fnc`, {
          params: this.query
        })
        this.query.last_page = Number(res?.data?.data?.last_page) || 0
        this.query.page = Number(res?.data?.data?.current_page) || 1
        this.rows = res.data.data.data || []
      } catch (err) {
        showErrorMessage(err)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    getStatus({ query }) {
      return getOptions(`${API_ENDPOINT.FNC_STATUS}`, {
        key: query
      }, 'label', 'value')
    },
    setFilterValue(type) {
      const initialFilterState = {
        filter_month: '',
        filter_year: '',
        filter_grade: '',
        filter_status: '',
        filter_issue: '',
        filter_application: '',
      };

      if (type === 'reset') {
        this.query = {
          ...this.query,
          page: 1,
          ...initialFilterState,
        };
        this.filter = { ...initialFilterState };
      } else {
        this.query = {
          ...this.query,
          page: 1,
          filter_month: this.filter.filter_month || '',
          filter_year: this.filter.filter_year || '',
          filter_grade: this.filter.filter_grade || '',
          filter_status: this.filter.filter_status?.value || '',
          filter_issue: this.filter.filter_issue || '',
          filter_application: this.filter.filter_application || ''
        };
      }
    },

    statusBackground(color, type) {
      const options = type == 'status' ? STATUS : DETAIL_STATUS
      return getStatusColor(color, options)
    }
  },
  async created() {
    await this.get()
  },
  computed: {
    options() {
      return {
        months: getMonthList(),
        years: getYearList()
      }
    },
    downloadUrl() {
      const params = new URLSearchParams(this.query).toString()
      return `/fnc-download?${params}`
    },
    queryWatcher() {
      return {
        page: this.query.page,
        per_page: this.query.per_page,
        search: this.query.search,
        filter_month: this.query?.filter_month,
        filter_year: this.query?.filter_year,
        filter_grade: this.query?.filter_grade,
        filter_status: this.query?.filter_status,
        filter_issue: this.query?.filter_issue,
        filter_application: this.query?.filter_application,
      }
    }
  },
  watch: {
    queryWatcher(newVal, oldVal) {
      if (newVal.perpage !== oldVal.perpage || newVal.search !== oldVal.search) {
        this.query.page = 1
      }
      this.$router.replace({ query: this.query }).catch(() => { })
      this.get()
    },
    '$route': {
      handler(newVal) {
        if (Object.keys(newVal.query).length === 0) {
          this.query.page = 1
          this.$router.replace({
            query: {
              per_page: this.$route?.query?.per_page || 10,
              page: this.$route?.query?.page || 1,
              search: this.$route?.query?.search || '',
              last_page: 0,
              filter_month: this.$route?.query?.filter_month || '',
              filter_year: this.$route?.query?.filter_year || '',
              filter_grade: this.$route?.query?.filter_grade || '',
              filter_status: this.$route?.query?.filter_status || '',
              filter_issue: this.$route?.query?.filter_issue || '',
              filter_application: this.$route?.query?.filter_application || '',
            }
          }).catch(() => { }).finally(() => {
            this.get()
          })
        }
      }, immediate: false
    }
  }
}
</script>

<style></style>
